import * as yup from 'yup';

export const editGeneralValidation = yup.object({
  dob: yup.string().required('Date of Birth is required').nullable(),
  firstName: yup.string().required('First Name is required'),
  lastName: yup.string().required('Last Name is required'),
});
